import {
  GenericWidgetSemantics,
  OPCUAGaugeSemantics,
  WidgetSemantics,
} from "@src/types/dashboards";

/**
 * Demo value used when a widget has no live data yet — for the picker preview
 * and for a freshly placed widget on the canvas. Sits at ~68% of the range so
 * the needle reads as "populated" and stays distinct from the target marker.
 * Tolerates `undefined` semantics (templates/catalog previews that don't
 * carry one yet) so callers can use a single fallback chain without
 * re-guarding at every call site.
 */
export const getPlaceholderValue = (
  semantics?: WidgetSemantics | null,
): number => {
  const s = (semantics ?? {}) as Partial<
    OPCUAGaugeSemantics & GenericWidgetSemantics
  >;
  const min = s.min_value ?? 0;
  const max = s.max_value ?? 100;
  return Math.round(min + 0.68 * (max - min));
};
